/* BYOKA LABS — storefront behaviour
   Research-use gate · mobile nav · header search · product quantity tiers ·
   gallery thumbs · COA lot lookup. No dependencies. */
(function () {
  'use strict';

  var GATE_KEY = 'byoka:ruo-ack';

  /* ---------------------------------------------------------------- gate */
  function initGate() {
    var gate = document.querySelector('[data-byk-gate]');
    if (!gate) return;

    var force = document.documentElement.classList.contains('shopify-design-mode');
    var acked = false;
    try {
      acked = window.localStorage.getItem(GATE_KEY) === '1';
    } catch (e) {
      acked = false;
    }

    if (acked && !force) {
      gate.remove();
      return;
    }

    gate.hidden = false;
    document.body.classList.add('byk-gate-open');

    gate.addEventListener('click', function (event) {
      var accept = event.target.closest('[data-byk-gate-accept]');
      var exit = event.target.closest('[data-byk-gate-exit]');
      if (!accept && !exit) return;
      event.preventDefault();

      if (accept) {
        try {
          window.localStorage.setItem(GATE_KEY, '1');
        } catch (e) {
          /* private mode — gate reappears next visit */
        }
        gate.hidden = true;
        document.body.classList.remove('byk-gate-open');
      } else {
        window.location.href = exit.getAttribute('href') || 'https://www.google.com';
      }
    });
  }

  /* -------------------------------------------------------- header menus */
  function initHeader() {
    document.addEventListener('click', function (event) {
      var burger = event.target.closest('[data-byk-burger]');
      if (burger) {
        event.preventDefault();
        var nav = document.querySelector('[data-byk-mobile-nav]');
        if (nav) nav.classList.toggle('is-open');
        return;
      }

      var searchToggle = event.target.closest('[data-byk-search-toggle]');
      if (searchToggle) {
        event.preventDefault();
        var panel = document.querySelector('[data-byk-search-panel]');
        if (!panel) return;
        panel.classList.toggle('is-open');
        if (panel.classList.contains('is-open')) {
          var input = panel.querySelector('input[type="search"], input[name="q"]');
          if (input) input.focus();
        }
      }
    });
  }

  /* ------------------------------------------------------ quantity tiers */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (!format) return '$' + amount;
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function initTiers(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-byk-tiers]').forEach(function (group) {
      var formId = group.getAttribute('data-form');
      var priceEl = document.querySelector('[data-byk-line-price][data-form="' + formId + '"]');
      var unit = parseInt(group.getAttribute('data-unit-price'), 10) || 0;
      var format = group.getAttribute('data-money-format') || '';
      var qtyInputs = document.querySelectorAll('[data-byk-qty="' + formId + '"]');

      group.querySelectorAll('[data-byk-tier]').forEach(function (button) {
        button.addEventListener('click', function () {
          var qty = parseInt(button.getAttribute('data-qty'), 10) || 1;
          var off = parseFloat(button.getAttribute('data-off')) || 0;

          group.querySelectorAll('[data-byk-tier]').forEach(function (other) {
            other.classList.toggle('is-active', other === button);
          });

          qtyInputs.forEach(function (input) {
            input.value = qty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          if (priceEl && unit) {
            priceEl.textContent = formatMoney(Math.round(unit * qty * (1 - off)), format);
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------- gallery */
  function initGallery(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-byk-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-byk-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-byk-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          var img = main.querySelector('img');
          if (img) {
            img.setAttribute('src', src);
            img.setAttribute('srcset', '');
            img.setAttribute('alt', alt);
          }
          gallery.querySelectorAll('[data-byk-thumb]').forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        });
      });
    });
  }

  /* -------------------------------------------------------- COA lookup */
  function initCoaLookup(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-byk-coa]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('input');
        var lot = (input && input.value || '').trim();
        if (!lot) return;
        window.location.href = '/search?q=' + encodeURIComponent(lot) + '&type=product,page,article';
      });
    });
  }

  function boot(scope) {
    initTiers(scope);
    initGallery(scope);
    initCoaLookup(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGate();
    initHeader();
    boot(document);
  });

  /* Theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    initGate();
  });
})();
